import FeatureCodes from '../enums/feature-codes';
import { FeatureUsage } from '../types/feature-usage';

export const getAccountEmailSendingDetails = (featureUsages: FeatureUsage[]) =>
  featureUsages.find(
    ({ featureCode }) => featureCode === FeatureCodes.EmailSending,
  );

export const isProspectMaxActive = (featureUsages: FeatureUsage[]) =>
  featureUsages?.find(
    ({ featureCode }) => featureCode === FeatureCodes.ProspectMaxActive,
  );
